import PropTypes from 'prop-types';
import Media from '../../components/media/Media';
import TrackEventLink from '../../components/track-event-link/TrackEventLink';

import CreateProjectButton from '../../components/create-project-button/CreateProjectButton';
import { PageTitle } from '../../components/typography/Heading';

const HowProjectWorks = (props) => (
    <div className={`${props.className || ''} require-rest-height flat-blue`}>
        <section className="page-width content padding-page-normal-large center">
            <PageTitle tag={'h2'}>{props.title}</PageTitle>
            <div className="row">
                <div className="col-md-4 col-xs-12">
                    <Media image="highfive.svg" title="Start en spleis">
                        Fortell hva du trenger penger til og hvorfor. Sett et mål for innsamlingen og du er klar på 30
                        sekunder.
                    </Media>
                </div>
                <div className="col-md-4 col-xs-12">
                    <Media image="trompetspiller.svg" title="Engasjer folk">
                        Del innsamlingen slik at de som heier på deg kan gi penger og følge med på hvordan det går.
                    </Media>
                </div>
                <div className="col-md-4 col-xs-12">
                    <Media image="heiegruppe.svg" title="Store ting kan skje">
                        Når du har samlet pengene du trenger blir de utbetalt og du kan gjennomføre målet ditt.
                        Gratulerer!
                    </Media>
                </div>
            </div>
            <CreateProjectButton label={props.title} />
            <TrackEventLink
                to="/hva-er-spleis"
                category="content"
                action="from-how-spleis-works"
                style={{ display: 'block', margin: '2rem auto 0 auto' }}
            >
                Jeg vil vite mer
            </TrackEventLink>
        </section>
    </div>
);

HowProjectWorks.propTypes = {
    title: PropTypes.string.isRequired,
    className: PropTypes.string,
};

export default HowProjectWorks;
